import { useEffect, useRef, useState } from 'react';
import Box from '../../components/layout/Box';
import * as eva from 'eva-icons';
import debounce from 'lodash/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery, gql } from '@apollo/client';

import './styles.css';

import Search from './Search';
import SearchInput from './SearchInput';
import MobileMenu from '../MobileMenu';
import Logo from './Logo';
import { setRecent } from '../../state/search/actions';
import { useNavigate } from 'react-router-dom';

const LIST_PRODUCTS = gql`
  query ListProducts(
    $searchString: String
    $sorting: Sorting
    $pagination: Pagination
  ) {
    listProducts(
      searchString: $searchString
      sorting: $sorting
      pagination: $pagination
    ) {
      id
      title
      subtitle
      thumbnail
      author
    }
  }
`;

const Navbar = () => {
  const inputRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    eva.replace();
  });

  const recent = useSelector((state) => state.search.recent);

  const leftNavbarOpen = useSelector(
    (state) => state.navigation.leftNavbarOpen,
  );

  const debounceSearch = debounce((value) => {
    setSearch(value);
  }, 500);

  const [search, setSearch] = useState('');
  const [inputFocused, setInputFocused] = useState(false);

  const { data: productData } = useQuery(LIST_PRODUCTS, {
    variables: {
      searchString: search,
      pagination: {
        limit: 6,
      },
      sorting: {
        orderBy: 'publicationDate',
        order: 'DESC',
      },
    },
    skip: !search,
  });

  const products = productData?.listProducts || [];

  const handleResetSearch = () => {
    setSearch('');
    setInputFocused(false);
    inputRef.current.value = '';
    inputRef.current.blur();
  };

  const updateRecentSearches = (value) => {
    const filtered = recent.filter((str) => str !== value).slice(0, 9);
    const updatedRecentSearches = [value, ...filtered];
    dispatch(setRecent(updatedRecentSearches));
  };

  const handleSearch = (value) => {
    const searchValue = value || search;
    handleResetSearch();
    updateRecentSearches(searchValue);
    navigate(`/search?q=${searchValue}`);
  };

  return (
    <Box id="navbar-container" style={{ left: leftNavbarOpen ? 300 : 58 }}>
      <Box className="w-100 h-100 align-items-center px-2">
        <Logo />

        <SearchInput
          inputRef={inputRef}
          debounceSearch={debounceSearch}
          setInputFocused={setInputFocused}
          onSearch={handleSearch}
        />

        <MobileMenu />
      </Box>

      {inputFocused && (
        <Search
          products={products}
          searchString={search}
          onSearch={handleSearch}
          onReset={handleResetSearch}
        />
      )}
    </Box>
  );
};

export default Navbar;
